export enum RackEnum{
    Fabric = 'Fabric',
    Trim='Trim'
  }